import { render, staticRenderFns } from "./RegionPrint.vue?vue&type=template&id=50babf09&scoped=true&"
import script from "./RegionPrint.vue?vue&type=script&lang=js&"
export * from "./RegionPrint.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50babf09",
  null
  
)

export default component.exports